import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getEmailTemplateList = createAsyncThunk(
    "getEmailTemplateList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/email-template/email-template-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const EmailTemplateSlice = createSlice({
    name: "EmailTemplateSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEmailTemplateList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getEmailTemplateList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getEmailTemplateList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default EmailTemplateSlice.reducer;
